<!-- <div *ngIf="shouldDisplayImage()" class="image-container-banner">
    <a href="assets/pdf/winter-warmer-specials.pdf" target="_blank">
        <img src="assets/images/special002-main.jpg" alt="Image Description">
    </a>
</div> -->

<div *ngIf="(breadcrumbItems$ | async).length > 0" id="breadcrumb" class="section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <ul class="breadcrumb-tree">
                    <li *ngFor="let item of (breadcrumbItems$ | async); let i=index">
                        <a [href]="item.currentUrl" [class.active]="(breadcrumbItems$ | async).length === (i + 1)">{{item.text}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

            
            <!-- Banner -->
         


<!-- Floating image on the right side of the screen 
<div class="floating-image">
    <img src="assets/images/special001.jpg" alt="Floating Image">
</div>
-->
